import React, { useEffect, useState } from 'react';

import { Dropdown as AntDDropdown } from 'antd';
import styled from 'styled-components';

import DownCaretIcon from '../../common/Icons/DownCaretIcon';

const StyledDropdown = styled(AntDDropdown)`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const StyledDropdownMenu = styled.div`
  .ant-dropdown-menu {
    padding: 0;
    border-radius: 0;
    border: 1px solid var(--line-gray);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    width: 155px;
    max-height: 160px;
    overflow-y: auto;

    .ant-dropdown-menu-item {
      font-size: 12px;
    }
  }
`;

const Label = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;

  gap: 2px;

  span {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

interface Props {
  selection: number;
  options: any[];
  onSelect: any;
}

const DropdownLabel = ({ selection, options, onSelect }: Props) => {
  const [selectedItem, setSelectedItem] = useState<any>(undefined);

  useEffect(() => {
    const currentSelectedItem = options?.find((item: any) => item.id === selection);

    if (currentSelectedItem) {
      setSelectedItem(currentSelectedItem);
    } else if (options?.length > 0) {
      setSelectedItem(options[0]);
    }
  }, [selection]);

  const items = options.map((item: any) => ({
    key: item.id,
    label: item.name,
    onClick: () => onSelect(item.id),
  }));

  return (
    <StyledDropdown
      dropdownRender={(menu) => <StyledDropdownMenu>{menu}</StyledDropdownMenu>}
      menu={{ items, selectable: true, selectedKeys: selectedItem ? [(selectedItem?.id).toString()] : undefined }}
      trigger={['click']}
    >
      <Label style={{ cursor: 'pointer' }}>
        <span>{selectedItem?.name}</span>
        <DownCaretIcon />
      </Label>
    </StyledDropdown>
  );
};

export default DropdownLabel;
